import React from 'react';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';
import { StudentTransactionMatrixItem } from '../../../types/paymentScheme';
import { getPaymentDetailsColumns } from '../utils/paymentDetailsTableColumns';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { useSelector } from 'react-redux';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { RootState } from '../../../redux/store';

interface PaymentDetailsTableProps {
  title: string;
  feeDetails: StudentTransactionMatrixItem[];
  isLoading: boolean;
  checkboxSelection?: boolean;
  onRowSelectionModelChange?: (selectionModel: GridRowSelectionModel) => void;
  onUpdateStatusClick?: (transaction: StudentTransactionMatrixItem) => void;
  onViewReceiptClick?: (transaction: StudentTransactionMatrixItem) => void;
  onDownloadReceiptClick?: (transaction: StudentTransactionMatrixItem) => void;
  onSendReceiptClick?: (transaction: StudentTransactionMatrixItem) => void;
  onCancelPaymentClick?: (transaction: StudentTransactionMatrixItem) => void;
}

const PaymentDetailsTable: React.FC<PaymentDetailsTableProps> = ({
  title,
  feeDetails,
  isLoading,
  checkboxSelection = false,
  onRowSelectionModelChange,
  onUpdateStatusClick,
  onViewReceiptClick,
  onDownloadReceiptClick,
  onSendReceiptClick,
  onCancelPaymentClick
}) => {
  const { paymentUser } = useSelector((state: RootState) => state.paymentUser);
  const columns: GridColDef[] = getPaymentDetailsColumns(paymentUser, {
    onUpdateStatusClick,
    onViewReceiptClick,
    onDownloadReceiptClick,
    onSendReceiptClick,
    onCancelPaymentClick
  });

  return (
    <Box mb='24px'>
      <Typography variant='h6' mb='16px' fontWeight='bold'>
        {title}
      </Typography>
      <Box sx={{ width: '100%' }}>
        <DataGrid
          rows={feeDetails}
          columns={columns}
          loading={isLoading}
          checkboxSelection={checkboxSelection}
          onRowSelectionModelChange={onRowSelectionModelChange}
          getRowId={(row) => row._id}
          disableColumnMenu
          pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
          initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
          sx={{
            ...dataGridSx(pallet),

            '& .MuiDataGrid-virtualScroller': {
              overflowY: 'auto'
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default PaymentDetailsTable;
